// extracted by mini-css-extract-plugin
export var active = "_4j-7";
export var container = "_4j-0";
export var evenWidth = "_4j-4";
export var large = "_4j-5";
export var outlet = "_4j-8";
export var slide = "_4j-2";
export var small = "_4j-6";
export var tab = "_4j-3";
export var tabs = "_4j-1";